(function () {
    "use strict";

    angular.module("app").component("securityIncidentComments", {
        template: `
        <style>
            .comment { padding: 10px; border-left: 4px solid lightgray; }
            .comment:not(:last-child) { margin-bottom: 15px; }
            .comment-info { display: flex; }
            .comment-info__author { flex-grow: 1; }
            .comment-info__timestamp { font-size: small; }
            .add-comment-container { position: absolute; top: 16px; right: 0; margin-right: 30px; }
            .comment .message { white-space: pre; }
        </style>
                   
        <div class="add-comment-container" ng-if="$ctrl.canAdd">
            <button type="button" class="btn btn-primary" ng-click="$ctrl.addComment()"><i class="fa-solid fa-circle-plus"></i>&nbsp;{{'Comment_AddTitle' | habilTranslation}}</button>
        </div>

        <div ng-if="$ctrl.comments.length">
            <div class="comment" ng-repeat="comment in $ctrl.comments">
                <div class="message">{{comment.Message}}</div>
                <hr class="compact">
                <div class="comment-info">
                    <span class="comment-info__author">{{comment.CreatedBy}}</span><span class="comment-info__timestamp">{{comment.DateTime | date:'dd/MM/yyyy HH:mm:ss'}}</span>
                </div>
            </div>
        </div>
        <div ng-if="!$ctrl.comments.length">
            <span i18n="Comment_None"></span>
        </div>`,
        bindings: {
            securityIncident: "<?",
            securityIncidentId: "@?",
        },
        controller: SecurityIncidentCommentsController,
        controllerAs: "$ctrl"
    });

    SecurityIncidentCommentsController.$inject = [
        "$rootScope", "$scope", "controllerDecorator", "userFunctions",
        "securityIncidentsApi",
    ];
    function SecurityIncidentCommentsController(
        $rootScope, $scope, controllerDecorator, userFunctions,
        securityIncidentsApi,
    ) {
        const $controller = this;
        controllerDecorator.Decorate($controller, ["dialog"]);

        $controller.comments = [];
        $controller.canAdd = true;
        $controller.addComment = addComment;

        const isNsaUser = userFunctions.currentUserHasRole("NVO-App");
        const isSecurityOfficer = userFunctions.currentUserHasRole("VO-App");

        $scope.$watch(() => $controller.securityIncident, (value) => {
            if (!value || !value.PublicId) {
                return;
            }

            getComments(value.PublicId);
        });

        $scope.$watch(() => $controller.securityIncidentId, (value) => {
            if (!value) {
                return;
            }

            getComments(value);
        });

        initialize();

        function initialize() {
            if (!$controller.securityIncidentId && !$controller.securityIncident) {
                return;
            }

            getComments($controller.securityIncidentId ?? $controller.securityIncident.PublicId);
        }

        function getComments(publicId) {
            securityIncidentsApi.GetComments(publicId)(comments => {
                $controller.comments = comments;
            });
        }

        function addComment() {
            const $dialogScope = $rootScope.$new(true);

            $dialogScope.visibleForSecurityOfficer = false;
            $dialogScope.comment = "";

            const dialogOptions = {
                templateHtml: `
                <div>
                    <div class="row space-below"><textarea class="form-control" style="resize: vertical; max-height: 10em; min-height: 4em; width: 100%; padding: 4px;" rows="5" ng-model="comment"></textarea></div>
                    ${isNsaUser ? `<div class="row">
                        <fodbz-checkbox fodbz-model="visibleForSecurityOfficer"
                                        fodbz-field-const="checkbox-vivisble-for-so"
                                        fodbz-resource="{{'VisibleForSecurityOfficer' | habilTranslation}}">
                        </fodbz-checkbox>
                    </div>` : ""}
                </div>`,
                scope: $dialogScope,
                onEscape: true,
                size: "medium",
                title: $controller.getTranslation("Comment_AddTitle"),
                closeButton: true,
                buttons: {
                    confirm: {
                        label: $controller.getTranslation("Comment_Add"),
                        className: "btn-primary",
                        callback: onSubmit,
                    },
                    cancel: {
                        label: $controller.getTranslation("Button_Cancel"),
                        className: "btn-default",
                    }
                }
            };

            $controller.Dialog.Custom(dialogOptions);

            async function onSubmit() {
                const message = $dialogScope.comment?.trim();

                if (!message) {
                    return;
                }

                const securityIncidentId = $controller.securityIncidentId ?? $controller.securityIncident.PublicId;
                const comment = { message, forRole: isSecurityOfficer || (isNsaUser && $dialogScope.visibleForSecurityOfficer) ? "VO-App" : undefined };

                securityIncidentsApi.AddComment(securityIncidentId)(comment, (response) => {
                    if (!response?.data) {
                        return;
                    }

                    $controller.comments = response.data;
                });
            }
        }
    }
})();